// Main application entry point
import './App.css';
import { BrowserRouter } from 'react-router-dom';
//import HomePage from './pages/Home';
import Router from './routes';

/**
 * App Component
 * Root component that sets up the application structure
 * - Wraps the entire app in BrowserRouter for navigation
 * - Renders the main Router component that handles all routes
 */
function App() {
  return (
    <BrowserRouter>
      <div className="App">
        {/* <HomePage /> */}
        <Router />
      </div>
    </BrowserRouter>
  );
}

export default App;
